"use client";

import NextLink from "next/link";
import { ComponentProps } from "react";
import { useLang } from "./useLang";

interface LinkProps extends ComponentProps<typeof NextLink> {
  lang?: string;
}

export default function Link(props: LinkProps) {
  const locale = useLang();

  return (
    <NextLink {...props} href={`/${props.lang ?? locale}${props.href}`}>
      {props.children}
    </NextLink>
  );
}
